import { Link } from "react-router-dom";
import { SlidersHorizontal, Send, PenTool, BadgeCheck, PackageCheck } from "lucide-react";
import { Reveal } from "./motion";
import { DELIVERY_DELAY } from "../config/site";

const STEPS = [
  { icon: SlidersHorizontal, t: "Configurez", d: "Depuis le configurateur : votre logo, une couleur totalement libre, un style, vos liens — puis « Commander ma carte sur WhatsApp »." },
  { icon: Send, t: "Envoyez", d: "Vous nous transmettez votre logo et vos idées directement dans la conversation WhatsApp." },
  { icon: PenTool, t: "Nous dessinons", d: "Noveocard crée votre visuel sur-mesure : cadres, ornements, dégradés, mise en page, icônes — et vous l'envoie." },
  { icon: BadgeCheck, t: "Vous validez", d: "Vous demandez des modifications si besoin, puis validez. Rien n'est produit sans votre accord." },
  { icon: PackageCheck, t: "Vous recevez", d: DELIVERY_DELAY.replace("la commande", "le visuel") },
];

export default function SurMesure() {
  return (
    <section className="grain relative overflow-hidden bg-nuit-900 py-20 text-white sm:py-28" data-testid="surmesure-section">
      <div
        className="pointer-events-none absolute inset-0"
        style={{ background: "radial-gradient(50% 40% at 85% 15%, rgba(22,119,255,0.18) 0%, transparent 70%)" }}
        aria-hidden="true"
      />
      <div className="container-nv relative">
        <Reveal className="max-w-3xl">
          <p className="eyebrow text-electric-300">Votre carte, sur-mesure</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight sm:text-5xl">
            Pas un logo sur une couleur. Une carte dessinée pour vous.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:text-lg">
            Chaque carte est créée sur-mesure avec une finition premium — cadre foil, ornements,
            dégradés, icônes, verso complet.{" "}
            <strong className="text-white">
              Personnalisation sur-mesure incluse, validée avec vous avant production.
            </strong>
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.07}>
              <article className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm transition-colors duration-500 hover:border-electric/50">
                <div className="flex items-center justify-between">
                  <s.icon className="h-6 w-6 text-electric-300" />
                  <span className="font-display text-3xl font-bold text-white/10" aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-4 font-display text-lg font-bold">{s.t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-white/65">{s.d}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 flex flex-col items-center gap-3 text-center">
          <p className="max-w-xl text-sm text-white/55">
            Le règlement se fait directement avec Noveocard, hors du site — aucun paiement en ligne,
            aucune surprise.
          </p>
          <Link
            to="/personnalisation"
            data-testid="surmesure-configurator-link"
            className="inline-flex items-center justify-center rounded-full bg-white px-7 py-3.5 font-display font-semibold text-nuit-900 transition-[transform,background-color] duration-300 hover:-translate-y-0.5 hover:bg-brume-200"
          >
            Configurer ma carte
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
